import { Reveal, SectionHeading } from "@/components/motion";
import { ArrowRight } from "lucide-react";

const WhatItDoes = () => (
  <section data-testid="what-it-does" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <SectionHeading index="02" eyebrow="The Neutral Referee" title="What GeoVerify actually does" />
      </div>
      <div className="lg:col-span-7 lg:pt-16">
        <Reveal delay={0.1}>
          <p className="text-base md:text-lg leading-relaxed text-foreground max-w-2xl">
            GeoVerify is the neutral referee that sits above your routing, dispatch, TMS, and fleet
            systems. We don&apos;t replace your tools — <span className="font-semibold">we verify them.</span>{" "}
            We turn movement, photos, GPS, and timestamps into liability-grade truth.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-12 border border-border divide-y divide-border font-mono text-sm">
            {[
              ["YOUR ROUTING ENGINE", "provides the plan"],
              ["YOUR DRIVER", "provides the claim"],
              ["YOUR DEVICES", "provide the telemetry"],
              ["GEOVERIFY", "tells you what actually happened"],
            ].map(([who, what], i) => (
              <div key={who} className={`flex items-center justify-between px-6 py-5 ${i === 3 ? "bg-foreground text-background" : ""}`}>
                <span className="tracking-widest text-xs">{who}</span>
                <span className={`flex items-center gap-3 text-xs sm:text-sm ${i === 3 ? "" : "text-muted-foreground"}`}>
                  {what} <ArrowRight className="w-4 h-4 shrink-0" />
                </span>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default WhatItDoes;
